import React from 'react';
import { Button, Col, FormGroup, FormInput, Row } from 'shards-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import type { ConditionOptionsSearchParams } from '../../../types/condition';

interface GridConditionOptionsProps {
  isLoading: boolean;
  searchParams: ConditionOptionsSearchParams | undefined;
  isDisabledCustomer1: boolean;
  isDisabledCustomer2: boolean;
  isDisabledCustomer3: boolean;
  isDisabledDeliveryLocation: boolean;
  isDisabledStandard: boolean;
  isDisabledSizeDiameter: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

const SearchConditionOptionsForm = ({
  isLoading,
  searchParams,
  isDisabledCustomer1,
  isDisabledCustomer2,
  isDisabledCustomer3,
  isDisabledDeliveryLocation,
  isDisabledStandard,
  isDisabledSizeDiameter,
  onChange,
  onSearch,
}: GridConditionOptionsProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // 確認用
  // const handleCheck = (): void => {
  //   if (gridApi) {
  //     const hoge = gridApi.getSelectedRows();
  //     const fuga = gridApi.getDisplayedRowCount();
  //     console.log('selected rows: ', hoge);
  //     console.log('row count: ', fuga);
  //   }
  // };

  // VIEW
  // ================================================================================

  return (
    <>
      <h5 className="mt-4">{t('condition.search')}</h5>
      <Row className="mt-2 mb-1 ml-4">
        {!isDisabledCustomer1 && (
          <Col>
            <FormGroup>
              <FormInput id="customer1" placeholder={t('condition.customer1')} value={searchParams?.customer1 ?? ''} disabled={isDisabledCustomer1} onChange={onChange} />
            </FormGroup>
          </Col>
        )}
        {!isDisabledCustomer2 && (
          <Col>
            <FormGroup>
              <FormInput id="customer2" placeholder={t('condition.customer2')} value={searchParams?.customer2 ?? ''} disabled={isDisabledCustomer2} onChange={onChange} />
            </FormGroup>
          </Col>
        )}
        {!isDisabledCustomer3 && (
          <Col>
            <FormGroup>
              <FormInput id="customer3" placeholder={t('condition.customer3')} value={searchParams?.customer3 ?? ''} disabled={isDisabledCustomer3} onChange={onChange} />
            </FormGroup>
          </Col>
        )}
        {!isDisabledDeliveryLocation && (
          <Col>
            <FormGroup>
              <FormInput
                id="deliveryLocation"
                placeholder={t('deliveryLocation.deliveryLocation')}
                value={searchParams?.deliveryLocation ?? ''}
                disabled={isDisabledDeliveryLocation}
                onChange={onChange}
              />
            </FormGroup>
          </Col>
        )}
        {!isDisabledStandard && (
          <Col>
            <FormGroup>
              <FormInput id="standard" placeholder={t('millSheet.standard')} value={searchParams?.standard ?? ''} disabled={isDisabledStandard} onChange={onChange} />
            </FormGroup>
          </Col>
        )}
        {!isDisabledSizeDiameter && (
          <Col>
            <FormGroup>
              <FormInput id="sizeDiameter" placeholder={t('millSheet.size')} value={searchParams?.sizeDiameter ?? ''} disabled={isDisabledSizeDiameter} onChange={onChange} />
            </FormGroup>
          </Col>
        )}
        <Col sm={2} md={2}>
          {/* <Button onClick={handleCheck}>check</Button> */}
          <Button className="d-inline-block w-100" disabled={isLoading || !searchParams} onClick={onSearch}>
            {isLoading ? <FontAwesomeIcon className="cell-editor-icon" icon={faSpinner} spin={true} /> : t('filter.search')}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default SearchConditionOptionsForm;
